import { ANON_USER } from '@23degrees/shared-code/config/permissions';
const SESSION_KEY = 'auth';
const CONSENT_KEY = 'consent_accepted';
// it can be that local storage exists but access is blocked by browsers
// so we need a better check
const hasLocalStorage = () => {
  let hasAccess = true;
  try {
    localStorage.getItem('auth');
  } catch (e) {
    hasAccess = false;
  }

  return hasAccess;
};

export function getAuth() {
  try {
    let session;
    if (hasLocalStorage()) {
      try {
        session = localStorage.getItem(SESSION_KEY);
      } catch (error) {
        console.error('[localStorage] error get auth', error);
      }
    }
    // console.log('[storage][getAuth]', session ? JSON.parse(session) : ANON_USER);
    if (session) {
      const parsedSession = JSON.parse(session);

      // Filter out user with old storage and clear their cache!
      if (parsedSession.loggedIn !== undefined) throw Error('Old user session');

      if (parsedSession.user && parsedSession.user.id && parsedSession.user.token) {
        // console.log('[storage][getAuth]', 'Everything dandy, this user is nice');
        return parsedSession.user;
      } else {
        throw Error('parsedSession user not correct');
      }
    }
  } catch (e) {
    console.log('[storage][getAuth] Error getting auth from local store, clearing store, returning anon', e);
    clearEverything();
  }

  return ANON_USER;
}

export function saveAuth(session) {
  if (hasLocalStorage()) {
    try {
      localStorage.setItem(SESSION_KEY, JSON.stringify({ user: session }));
    } catch (error) {
      console.error('[localStorage] error save auth', error);
    }
  }
}

export function clearAuth() {
  if (hasLocalStorage()) {
    try {
      localStorage.removeItem(SESSION_KEY);
    } catch (error) {
      console.error('[localStorage] error clear auth', error);
    }
  }
}

export function getConsent() {
  let consent;
  if (hasLocalStorage()) {
    try {
      consent = localStorage.getItem(CONSENT_KEY);
    } catch (error) {
      console.error('[localStorage] error get consent', error);
    }
  }
  return consent ? JSON.parse(consent) : false;
}

export function setConsent(accepted) {
  if (hasLocalStorage()) {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(accepted));
    } catch (error) {
      console.error('[localStorage] error set consent', error);
    }
  }
}

export function clearConsent() {
  if (hasLocalStorage()) {
    try {
      localStorage.removeItem(CONSENT_KEY);
    } catch (error) {
      console.error('[localStorage] error remove consent', error);
    }
  }
}

export function clearEverything() {
  try {
    if (localStorage) localStorage.clear();
    if (location) location.reload();
  } catch (error) {
    console.error('[localStorage] error clear', error);
  }
}
